import Input from "../../../Atoms/Input";
import {TextEditor} from "../../../Atoms/TextEditor";
import {ChangeEvent, useState} from "react";
import Button from "../../../Atoms/Button";
import {ArrowBackSharp, SaveAltSharp} from "@mui/icons-material";
import {useMutation} from "@apollo/client";
import {createAdventure} from "../../../GraphQL/AdventureMutation";
import {GetAdventures, GetAdventures4User} from "../../../GraphQL/AdventureQueries";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {setActiveContent} from "../../../redux/slices/content/contentSlice";
import {ActiveContent} from "../../../redux/slices/content/contentType";
import {RootState} from "../../../redux/store";

export const AdventureCreate = () => {
    const dispatch = useAppDispatch();
    const user = useAppSelector((state: RootState) => state.user)

    const [adventureName, setAdventureName] = useState<string>('');
    const [adventureDesc, setAdventureDesc] = useState<string>('');

    const [createAdventureHook, {
        data: createAdventureData,
        loading: createAdventureLoading,
        error: createAdventureError
    }] = useMutation(createAdventure);

    const handleSaveAdventure = async () => {
        if (user.role > 2) {
            await createAdventureHook({
                variables: {
                    adventureName: adventureName,
                    adventureDescription: adventureDesc,
                    userId: Number(user.userId)
                },
                refetchQueries: [{
                    query: GetAdventures,
                }]
            });
        } else {
            await createAdventureHook({
                variables: {
                    adventureName: adventureName,
                    adventureDescription: adventureDesc,
                    userId: Number(user.userId)
                },
                refetchQueries: [{
                    query: GetAdventures4User,
                    variables: {
                        userId: Number(user.userId)
                    }
                }]
            });
        }


        dispatch(setActiveContent(ActiveContent.Adventure))
    }

    return (
        <div>
            <div className='row justify-content-start'>
                <div className='col-12 justify-content-start text-start'>
                    <Button onClick={() => dispatch(setActiveContent(ActiveContent.Adventure))}><ArrowBackSharp/> Zurück</Button>
                    <Button onClick={async () => await handleSaveAdventure()}><SaveAltSharp/> Speichern</Button>
                </div>
            </div>
            <div className='row mt-3 justify-content-center'>
                <div className='col-10'>
                    <Input label='Name des Abenteuers' value={adventureName}
                           onChange={(event: ChangeEvent<HTMLInputElement>) => setAdventureName(event.target.value)}/>
                </div>
            </div>
            <div className='row mt-3 justify-content-center'>
                <div className='col-10 justify-content-center'>
                    <TextEditor label='Beschreibung' onChange={(value: string) => setAdventureDesc(value)}
                                value={adventureDesc}/>
                </div>
            </div>
        </div>
    )
}